const c = /* @__PURE__ */ new Map(), o = (e) => {
  c.forEach(({ callback: t, isDisabled: s }, a) => {
    !s && a !== e.target && !a.contains(e.target) && t && t(e);
  });
}, u = {
  mounted(e, t) {
    if (!t.value)
      return;
    const s = { callback: t == null ? void 0 : t.value, isDisabled: !0 };
    c.set(e, s), document.addEventListener("click", o, !0), setTimeout(() => {
      s.isDisabled = !1;
    }, 0);
  },
  unmounted(e) {
    c.delete(e), c.size === 0 && document.removeEventListener("click", o, !0);
  }
};
export {
  u as default
};
